import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TableSortLabel,
    Pagination,
    CircularProgress,
} from "@mui/material";
import { displayDateFun } from 'app/utils/constants/functions';
import { fetchFinishedOrdersScrapInventory } from 'app/redux/actions/inventoryAction';
import moment from 'moment';
function OrderFinishedScrapTable({ searchTerm }) {

    const dispatch = useDispatch()
    const [order, setOrder] = useState("");
    const [orderBy, setOrderBy] = useState("fabric_code");
    const [page, setPage] = useState(1);
    const { ordersFinishedScrapDetails, error, TotalPage, loading } = useSelector(
        (state) => state.inventoryReducer
    );
    const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    const handleSort = (property) => {
        const isAscending = orderBy === property && order === "asc";
        setOrder(isAscending ? "desc" : "asc");
        setOrderBy(property);
    };

    const sortedData = ordersFinishedScrapDetails?.sort((a, b) => {
        let aValue;
        let bValue;

        aValue = a[orderBy];
        bValue = b[orderBy];

        if (order === "desc") {
            return aValue < bValue ? -1 : 1;
        } else {
            return bValue < aValue ? -1 : 1;
        }
    });
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        dispatch(fetchFinishedOrdersScrapInventory(searchTerm, "", newPage));
    };
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={
                                    orderBy === "order_no"
                                }
                                direction={order}
                                onClick={() =>
                                    handleSort("order_no")
                                }
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Order No.
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={
                                    orderBy === "order_item_name"
                                }
                                direction={order}
                                onClick={() =>
                                    handleSort("order_item_name")
                                }
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Order Item Name
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={
                                    orderBy === "order_sub_item_name"
                                }
                                direction={order}
                                onClick={() =>
                                    handleSort("order_sub_item_name")
                                }
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Order Sub Item Name
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                                color: "white",
                            }}
                        >
                            Order Created Date
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "order_item_kc_fabric_code"}
                                direction={order}
                                onClick={() => handleSort("order_item_kc_fabric_code")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                KC Fabric Code
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "order_item_job_work_id"}
                                direction={order}
                                onClick={() => handleSort("order_item_job_work_id")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Job Work ID
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "order_item_fabric_required"}
                                direction={order}
                                onClick={() => handleSort("order_item_fabric_required")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Order fabric received
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "finished_orders_scrap_fabric_available"}
                                direction={order}
                                onClick={() => handleSort("finished_orders_scrap_fabric_available")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                    minWidth: "140px"
                                }}
                            >
                                Fabric Scrap Available Quantity
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "order_item_status"}
                                direction={order}
                                onClick={() => handleSort("order_item_status")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Order Item Status
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "remark"}
                                direction={order}
                                onClick={() => handleSort("remark")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Remark
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "finished_orders_scrap_inventory_created_date"}
                                direction={order}
                                onClick={() => handleSort("finished_orders_scrap_inventory_created_date")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Created Date
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "left",
                                minWidth: "145px",
                                verticalAlign: "middle",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "finished_orders_scrap_inventory_updated_date"}
                                direction={order}
                                onClick={() => handleSort("finished_orders_scrap_inventory_updated_date")}
                                sx={{
                                    color: "white",
                                    "&:hover": { color: "white" },
                                    "&.MuiTableSortLabel-root.Mui-active": {
                                        color: "white",
                                    },
                                }}
                            >
                                Updated Date
                            </TableSortLabel>
                        </TableCell>
                        {/* {permissions?.inventory_edit === true && (
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "95px",
                                    verticalAlign: "middle",
                                    color: "white",
                                    px: 1,
                                    position: "sticky",
                                    right: 0,
                                    height: "58px",
                                    zIndex: 1,
                                    bgcolor: "#202020",
                                }}
                            >
                                Action
                            </TableCell>
                        )} */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? (<TableRow ><TableCell align="center" colSpan={12}><CircularProgress size="30px" />
                    </TableCell></TableRow>) :
                        (sortedData?.map((row, i) => (
                            <TableRow key={i}>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_no}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_item_name}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_sub_item_name}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_item_create_date == null
                                        ? "N/A"
                                        : displayDateFun(
                                            row?.order_item_create_date
                                        )}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_item_kc_fabric_code}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_item_job_work_id || "-"}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_item_status || "-"}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.order_item_fabric_required || 0}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.finished_orders_scrap_fabric_available || 0}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.remark || "-"}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.finished_orders_scrap_inventory_created_date ? moment(row?.finished_orders_scrap_inventory_created_date).format("DD-MM-YYYY") : "-"}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left" }}>
                                    {row?.finished_orders_scrap_inventory_updated_date ? moment(row?.finished_orders_scrap_inventory_updated_date).format("DD-MM-YYYY") : "-"}
                                </TableCell>
                                {/* {permissions?.inventory_edit === true && (
                                    <TableCell
                                        sx={{
                                            textAlign: "left",
                                            px: 1,
                                            position: "sticky",
                                            right: 0,
                                            zIndex: 1,
                                            bgcolor: "white",
                                        }}
                                    >
                                        <JumboDdMenu
                                            icon={<MoreHorizIcon />}
                                            menuItems={[
                                                {
                                                    icon: <EditLocationIcon />,
                                                    title: "Change Location",
                                                    action: "changeLocation",
                                                    data: row,
                                                },
                                                // {
                                                //     icon: <MiscellaneousServicesIcon />,
                                                //     title: "Add To Scrap",
                                                //     action: "finishedscrapped",
                                                //     data: row,
                                                // },
                                                {
                                                    icon: <AddCircleOutlineIcon />,
                                                    title: "Manually Issue",
                                                    action: "manuallyIssue",
                                                    data: row,
                                                },
                                            ]}
                                        // onClickCallback={handleItemAction}
                                        />
                                    </TableCell>
                                )} */}
                            </TableRow>
                        )))}
                </TableBody>

            </Table>
            <Pagination
                count={TotalPage || 1} // Replace with the actual total number of pages
                page={page}
                onChange={handleChangePage}
                sx={{
                    position: "sticky",
                    bottom: 0,
                    left: 0,
                    backgroundColor: "white",
                    borderTop: "1px solid #ddd",
                }}
            />
        </TableContainer>
    )
}





export default OrderFinishedScrapTable